import React, { useState, useEffect } from 'react';
import Button from '@hubins/components/Button';
import SearchInput from 'components/SearchInput';
import { LoadingBar } from '@hubins/components/LoadingIndicators';
import __ from 'localisation';
import ApiPaginationTable from 'modules/Tables/ApiPaginationTable';
import { Columns, Column } from 'components/Columns';
import './index.scss';

import { useMiddleman } from "helpers/MiddlemanContext";
import BackofficeProfileLink from "@hubins/components/BackofficeProfileLink";

const loadingObj = {
  toolsBeginning: <LoadingBar small />,
  name: <LoadingBar small />,
  national_identity_number: <LoadingBar small />,
  updated_at: <LoadingBar small />,
};

const loadingState = [loadingObj, loadingObj, loadingObj];

const headers = [
  {
    Header: "",
    accessor: "toolsBeginning",
    className: "rt-cell-button",
    width: 40,
  },
  {
    Header: __("name"),
    accessor: "name",
    Cell: ({ row }) => (
      <>
        {row?.original?.name && (
          <BackofficeProfileLink profileUuid={row?.original?.uuid}>
            {row?.original?.name}
          </BackofficeProfileLink>
        )}
      </>
    ),
  },
  {
    Header: __("ssn_org_num"),
    accessor: "national_identity_number",
    Cell: ({ row }) => (
      <>
        {row?.original?.national_identity_number && (
          <BackofficeProfileLink profileUuid={row?.original?.uuid}>
            {row?.original?.national_identity_number}
          </BackofficeProfileLink>
        )}
      </>
    ),
  },
  {
    Header: __("updated_at"),
    accessor: "updated_at",
  },
];

const Profiles = () => {
  const middleman = useMiddleman();

  const [profiles, setProfiles] = useState<any[]>([]);
  const [amountOfPages, setAmountOfPages] = useState<number>(-1);
  const [search, setSearch] = useState<string>("");
  const [selectedPage, setSelectedPage] = useState<number>(0);
  const [init, setInit] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(true);

  const fetchPage = (page: number, searchParam: string = "") => {
    setLoading(true);
    setSelectedPage(page - 1);
    middleman
      .get(
        `/ql/crm/search?page=${page}${searchParam ? `&search=${searchParam}` : ""}`,
      )
      .then((res) => {
        const formattedRes = res.data.data.map((item) => {
          return {
            ...item,
            toolsBeginning: (
              <Button
                href={`/dashboard/profiles/${item.uuid}`}
                className={`transparent`}
                icon="arrow-right"
                onlyIcon
              />
            ),
          };
        });

        setAmountOfPages(res.data.last_page);
        setProfiles(formattedRes);
        setLoading(false);
      });
  };

  const searchCallback = () => {
    fetchPage(1, search);
  };

  useEffect(() => {
    if (init) {
      const timeout = setTimeout(searchCallback, 1500);
      return () => {
        clearTimeout(timeout);
      };
    }
  }, [search]);

  const handlePageFetch = (index) => {
    fetchPage(index + 1, search);
    if (!init) {
      setInit(true);
    }
  };

  const handleSearchChange = (e) => {
    setSearch(e.target.value);
  };

  return (
    <>
      <div className="flex flex--row align-items-center space-between profiles__header">
        <SearchInput onChange={handleSearchChange} value={search} placeholder="Search client name, policy or SSN/Org-nr" loading={loading} className="profiles__header-searchinput" />
        <Button href="/dashboard/create" icon="add" size="large">
          {__("create")}
        </Button>
      </div>
      <Columns>
        <Column s="12">
          <ApiPaginationTable
            data={profiles ? profiles : loadingState}
            headers={headers}
            fetchData={handlePageFetch}
            pageCount={amountOfPages}
            index={selectedPage}
          />
        </Column>
      </Columns>
    </>
  )

};

export default Profiles;
